import { Tabs, Text, VSpacer } from '@/components/DesignSystem';
import { DashboardModal } from '@/pages/CustomerDashboard/DashboardModal';
import { ResolvedRewardsProgram, ResolvedTier } from '@/pages/CustomerDashboard/interfaces';
import { TierProgress } from '@/pages/CustomerDashboard/MyProgress/TierProgress';
import { SpendingBreakdown } from '@/pages/CustomerDashboard/MyProgress/SpendingBreakdown';
import { ApiCategory } from '@api/interfaces';
import { ApiFarmerRewards } from '@api/interfaces/ApiFarmerRewards';
import { ApiUser } from '@api/interfaces';
import { Divider, Tab } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface MyProgressModalProps {
  activeFarmerRewards: ApiFarmerRewards,
  activeProgram: ResolvedRewardsProgram,
  brandColor: string,
  categories: ApiCategory[],
  customerId: string,
  farmer: ApiUser,
  isReachedFinalTier: boolean,
  linkedAccounts: ApiUser[],
  nextTier: ResolvedTier,
  onClose: () => void,
  programs: ResolvedRewardsProgram[],
  rewards: ApiFarmerRewards[],
}

export const MyProgressModal = ({
  activeFarmerRewards,
  activeProgram,
  brandColor,
  categories,
  customerId,
  farmer,
  isReachedFinalTier,
  linkedAccounts,
  nextTier,
  onClose,
  programs,
  rewards,
}: MyProgressModalProps) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <DashboardModal
      hideCloseButtonIcon
      onClose={onClose}
      open
      testID="my-progress-modal"
      title={t(($) => $.customerDashboard.myProgress.title)}
    >
      <Tabs
        onChange={(_, value) => setSelectedTab(value)}
        sx={{ '.MuiTabs-indicator': { backgroundColor: brandColor } }}
        testID="my-progress-modal-tabs"
        value={selectedTab}
        variant="fullWidth"
      >
        <Tab
          label={
            <Text
              category="title-small"
              sx={{ color: selectedTab === 0 ? brandColor : '#525252' }}
            >
              {t(($) => $.customerDashboard.myProgress.tierProgress)}
            </Text>
          }
        />
        <Tab
          label={
            <Text
              category="title-small"
              sx={{ color: selectedTab === 1 ? brandColor : '#525252' }}
            >
              {t(($) => $.customerDashboard.myProgress.spendingBreakdown)}
            </Text>
          }
        />
      </Tabs>
      <Divider />
      <VSpacer size="5" />
      {selectedTab === 0 && (
        <TierProgress
          accountGroupRole={farmer.accountGroupRole}
          brandColor={brandColor}
          categories={categories}
          isReachedFinalTier={isReachedFinalTier}
          linkedAccounts={linkedAccounts}
          nextTier={nextTier}
          program={activeProgram}
          rewards={activeFarmerRewards}
        />
      )}
      {selectedTab === 1 && (
        <SpendingBreakdown
          accountGroupRole={farmer.accountGroupRole}
          activeFarmerRewards={activeFarmerRewards}
          activeProgram={activeProgram}
          brandColor={brandColor}
          categories={categories}
          customerId={customerId}
          farmerRewards={rewards}
          linkedAccounts={linkedAccounts}
          programs={programs}
        />
      )}
    </DashboardModal>
  );
};
